<template>
	<div>
		<FlowTreeBlock v-bind="props" v-on="listeners" ref="tree_block" />
	</div>
</template>

<script>
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { getService, getServiceActionCollection } from '@/store/modules/apps/getters';
import { getAction } from '@/store/modules/actions/getters';
import { getActionsOfApp } from '@/store/modules/apps/actions';
import { updateNode } from '@/store/modules/nodes/actions';
import { editNode } from '@/store/modules/selectedNode/getters';
import { setContextualDataState } from '@/store/modules/selectedWorkflow/actions';
import { setFocusedElement } from '@/store/modules/flowTree/actions';
import { selectedTaskId, selectedTaskNodes } from '@/store/modules/analytics/getters.js';
import { statusToColorMapping } from '@/components/TaskLog/TaskLogService.js';

import AppActionService from '@/utils/AppActionService';

import FlowTreeBlock from './FlowTreeBlock.vue';

export default {
	name: 'FlowTreeBlockDataProvider',
	components: { FlowTreeBlock },
	props: {
		blockData: { type: Object },
		isContextualBlock: { type: Boolean },
	},
	computed: {
		...mapGettersShorthand({ getService, getAction, editNode, getServiceActionCollection, selectedTaskId, selectedTaskNodes }),
		props() {
			return {
				...this.$attrs,
				blockData: this.blockData,
				actionData: this.actionData,
				appData: this.appData,
				isChosen: this.isChosen,
				isContextualBlock: this.isContextualBlock,
				originalAppData: this.originalAppData,
				debugBackgroundColor: this.debugBackgroundColor,
			};
		},
		nodeId() {
			return this.blockData.id;
		},
		nodeTaskData() {
			return this.selectedTaskNodes.find((node) => node.nodeId === this.nodeId);
		},
		nodeTaskStatus() {
			return this.nodeTaskData?.status;
		},
		listeners() {
			return { ...this.$listeners, updateNode: this.updateBlock, skipNode: this.skipNode };
		},
		isDebugging() {
			return !!this.selectedTaskId;
		},
		debugBackgroundColor() {
			if (!this.isDebugging || !this.nodeTaskStatus) {
				return null;
			}
			return statusToColorMapping[this.nodeTaskStatus];
		},
		originalAppData() {
			return this.getService(this.appId);
		},
		appData() {
			if (AppActionService.doesActionHasServiceActionCollection(this.actionData)) {
				return this.getServiceActionCollection(AppActionService.getActionServiceActionCollection(this.actionData));
			}
			return this.originalAppData;
		},
		actionData() {
			return this.getAction(this.actionId);
		},
		appId() {
			return this.blockData.service;
		},
		actionId() {
			return this.blockData.action;
		},
		isChosen() {
			return this.editNode?.id === this.nodeId;
		},
	},
	methods: {
		...mapActionsShorthand({ getActionsOfApp, updateNode, setContextualDataState, setFocusedElement }),
		getAppItems() {
			if (!this.appId || !this.blockData.service_version) {
				return;
			}
			// Todo: I don't think we need to do this for each block. move to the Tree component
			this.getActionsOfApp({ id: this.appId, version: this.blockData.service_version });
			// this.getAppProfiles();
		},
		updateBlock({ node }) {
			this.updateNode({ node });
		},
		async skipNode({ node }) {
			if (node.id === this.nodeId && this.isContextualBlock) {
				this.loading = true;
				try {
					await this.setContextualDataState({ state: false });
				} finally {
					this.loading = false;
				}
			}
		},
		focusMe() {
			if (this.isChosen && this.$refs.tree_block) {
				this.setFocusedElement(this.blockData.id);
			}
		},
	},
	mounted() {
		this.getAppItems();
		this.focusMe();
	},
	data() {
		return { loading: false };
	},
	watch: {
		isChosen() {
			this.focusMe();
		},
	},
};
</script>

<style lang="scss" scoped></style>
